import { useFormikContext } from 'formik'

import { BUTTON_HEIGHT_40 } from '../../../../Button'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../Form'
import { ProfileInfoWidgetRows } from '../../ProfileInfoWidgetRows'

import * as styles from './ProfileInfoWidgetFormFields.module.css'

function ProfileInfoWidgetFormFields({
  NotesField,
  config,
  notifications,
  options,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { dirty, isSubmitting } = useFormikContext()

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  function handleCancel() {
    onCancel({ dirty })
  }

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        Header: false,
        UploadComponent: false,
        cancelProps: {
          height: BUTTON_HEIGHT_40,
          onClick: handleCancel,
        },
        isSubmitting,
        submitProps: {
          disabled: !dirty,
          height: BUTTON_HEIGHT_40,
          isLoading: isSubmitting,
          title: 'Modal.SaveBtnKey',
        },
      }}
      className={styles.formBody}
    >
      <FormInlineNotifications notifications={notifications} />
      <FormFieldsContainer className={styles.fields}>
        <ProfileInfoWidgetRows
          NotesField={NotesField}
          config={config}
          options={options}
        />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default ProfileInfoWidgetFormFields
